import Link from "next/link";
import React, { useEffect, useState } from "react";
import { Home, Search, Plus, Music, User } from "lucide-react";
import { useRouter } from "next/router";
import { useAuth } from "../context/AuthProvider";
import { useAudioPlayer } from "./GlobalAudioPlayer";

// Phone nav (design language F): a dark floating pill with a lime Create
// button in the middle. Hidden while the global player is open, as before.
const BottomNavbar = () => {
  const { user } = useAuth();
  const router = useRouter();
  const { isPlaying } = useAudioPlayer();

  const tabs = [
    { icon: Home, label: "Home", href: "/", path: "/" },
    { icon: Search, label: "Voices", href: "/models", path: "/models" },
    { create: true, label: "Create", href: "/create", path: "/create" },
    {
      icon: Music,
      label: "Library",
      href: user ? "/library" : "/signup",
      path: "/library",
    },
    {
      icon: User,
      label: "Profile",
      href: user?.avatar ? `/@${user?.username}` : "/signup",
      path: user?.avatar ? "/@[id]" : "/signup",
    },
  ];

  const [isHidden, setIsHidden] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (!isPlaying) {
      setIsHidden(false);
      setTimeout(() => setIsVisible(true), 50);
    } else {
      setIsVisible(false);
      setTimeout(() => setIsHidden(true), 300);
    }
  }, [isPlaying]);

  return (
    <div
      className={`tw-fixed tw-bottom-4 tw-left-3 tw-right-3 tw-z-[52] tw-flex tw-justify-center md:tw-hidden ${isHidden ? "tw-hidden" : ""}`}
    >
      <nav
        className={`tw-flex tw-h-[68px] tw-w-full tw-max-w-md tw-items-center tw-justify-around tw-rounded-full tw-bg-jam-ink tw-px-2.5 tw-transition-all ${
          isVisible ? "tw-opacity-100" : "tw-opacity-0"
        }`}
      >
        {tabs.map((tab) => {
          if (tab.create) {
            return (
              <Link
                key={tab.label}
                href={tab.href}
                aria-label="Create a cover"
                className="tw-flex tw-h-[54px] tw-w-[54px] tw-items-center tw-justify-center tw-rounded-full tw-bg-jam-lime tw-text-jam-ink"
              >
                <Plus size={24} strokeWidth={3} />
              </Link>
            );
          }
          const Icon = tab.icon;
          const active = router.pathname === tab.path;
          return (
            <Link
              key={tab.label}
              href={tab.href}
              className={`tw-flex tw-flex-col tw-items-center tw-gap-0.5 tw-text-[11px] tw-font-extrabold tw-no-underline ${
                active ? "tw-text-white" : "tw-text-jam-soft"
              }`}
            >
              <Icon size={20} strokeWidth={2.4} />
              {tab.label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default BottomNavbar;
